/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import AbstractAuthorizationCallbackRouteV2 from "openstack-uicore-foundation/lib/security/abstract-auth-callback-route-v2";
import {
  getUserInfo,
  onUserAuth
} from "openstack-uicore-foundation/lib/security/actions";

const AuthorizationCallbackRoute = ({ getUserInfo, onUserAuth }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const callback = (backUrl) => {
    if (!backUrl) backUrl = "/app";
    // hack since history is deprecated in react-router-dom v7
    const history = { push: navigate };
    getUserInfo("groups", "", backUrl, history);
  };

  const redirectToError = (error) => (
    <Navigate to={`/error?error=${error}`} replace />
  );

  return (
    <AbstractAuthorizationCallbackRouteV2
      issuer={process.env.IDP_BASE_URL}
      audience={process.env.OAUTH2_CLIENT_ID}
      location={location}
      callback={callback}
      redirectToError={redirectToError}
      onUserAuth={onUserAuth}
    />
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  getUserInfo,
  onUserAuth
})(AuthorizationCallbackRoute);
